import { Observable, Subject } from 'rxjs';

export class ToastMessageRef {
  private readonly _afterClosed$ = new Subject<void>();

  public afterClosed$(): Observable<void> {
    return this._afterClosed$.asObservable();
  }

  public close(): void {
    this._afterClosed$.next();
    this._afterClosed$.complete();
  }
}
